/**
 * Cliente Hospital Local Service
 *
 * Handles linking/unlinking counting locations to client-hospital pairs.
 */
import apiClient from '../apiClient';

export interface LocalVinculado {
  id: number;
  local_contagem_id: number;
  local_nome: string;
  responsavel: string;
  telefone: string | null;
  ramal: string | null;
  email: string | null;
  ativo: boolean;
}

export interface LocalDisponivel {
  id: number;
  local: string;
  responsavel: string;
  telefone: string | null;
}

class ClienteHospitalLocalService {
  private readonly baseUrl = '/clientes';

  async getLocaisVinculados(clienteId: number, hospitalId: number): Promise<LocalVinculado[]> {
    const response = await apiClient.get<LocalVinculado[]>(
      `${this.baseUrl}/${clienteId}/hospitais/${hospitalId}/locais-contagem`
    );
    return response.data;
  }

  async getLocaisDisponiveis(clienteId: number, hospitalId: number): Promise<LocalDisponivel[]> {
    const response = await apiClient.get<LocalDisponivel[]>(
      `${this.baseUrl}/${clienteId}/hospitais/${hospitalId}/locais-contagem/disponiveis`
    );
    return response.data;
  }

  async vincularLocais(
    clienteId: number,
    hospitalId: number,
    localIds: number[]
  ): Promise<{ success: boolean; vinculos_criados: number; message: string }> {
    const response = await apiClient.post(
      `${this.baseUrl}/${clienteId}/hospitais/${hospitalId}/locais-contagem/vincular`,
      { local_ids: localIds }
    );
    return response.data;
  }

  async desvincularLocal(
    clienteId: number,
    hospitalId: number,
    localId: number
  ): Promise<void> {
    await apiClient.delete(
      `${this.baseUrl}/${clienteId}/hospitais/${hospitalId}/locais-contagem/${localId}`
    );
  }
}

export default new ClienteHospitalLocalService();
